'use client';

import { DataGrid } from '@mui/x-data-grid';
import { CSSProperties } from 'react';

import { styled } from '../../styles';
import { Theme } from '../../theme';
import { withNoFlip } from '../../utils';

import { DataGridVariant } from './types';

const getCellTypographyByVariant = (variant: DataGridVariant, theme: Theme) => {
  if (variant === 'medium') {
    return theme.typography.body3 as CSSProperties;
  }

  return theme.typography.body5 as CSSProperties;
};

const getHeadTypographyByVariant = (variant: DataGridVariant, theme: Theme) => {
  if (variant === 'medium') {
    return theme.typography.body6 as CSSProperties;
  }

  return theme.typography.body8 as CSSProperties;
};

export const StyledDataGrid = styled(DataGrid, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: DataGridVariant }>(({ theme, variant }) => ({
  border: 'none',

  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus,  .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
    },

  '& .MuiDataGrid-withBorderColor': {
    borderColor: theme.palette.divider,
  },

  '& .MuiDataGrid-columnHeaderTitle': {
    ...(theme.typography.body8 as CSSProperties),
  },

  '& .MuiDataGrid-columnHeaderTitleContainer': {
    ...getHeadTypographyByVariant(variant, theme),
  },

  '& .MuiDataGrid-cell': {
    ...getCellTypographyByVariant(variant, theme),
  },

  '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    padding: theme.spacing(0, 2),
  },

  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.text3,
  },

  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },

  '& .MuiDataGrid-main': {
    flexGrow: 1,
  },

  '& .MuiDataGrid-footerContainer': {
    border: 'none',
    justifyContent: 'flex-start',
  },

  '& .MuiTablePagination-displayedRows': {
    margin: 0,
    direction: withNoFlip('ltr') as CSSProperties['direction'],
    ...(theme.typography.body5 as CSSProperties),
  },
}));
